import React from 'react';
import LiquidacionFletes from '../../components/fletes/ImprimirLiquidacionFletes';

const ImprimirLiquidacionFletesPage: React.FC = () => {
  return (
    <div style={{ padding: '20px' , textAlign: 'center' , alignItems: 'center', justifyContent: 'center'}}>
        <h2>Comprobante Liquidación Fletes</h2>
        <LiquidacionFletes />
    </div>
  );
};

export default ImprimirLiquidacionFletesPage;